export {default} from './ReferralRecordExpiration';
